import * as React from 'react'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { useTranslation } from 'react-i18next'

type VendorUserInputErrors = {
  email: string
  lastName: string
  firstName: string
  [key: string]: string
}

type UserContactFormProps = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  values: {
    firstName: string
    lastName: string
    phone: string
    responsibilityDescription: string
    receiveRequestForProposals: boolean
  }
  onEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  email: string
  onReceiveRequestForProposalsChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void
  formErrors: VendorUserInputErrors
  isEdit?: boolean
}

const UserContactForm: React.FC<UserContactFormProps> = ({
  onChange,
  values,
  onEmailChange,
  email,
  onReceiveRequestForProposalsChange,
  onBlur,
  formErrors,
  isEdit = false
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Box sx={{ mt: 3, gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' } }} display="grid" gap={2}>
        <TextField
          autoFocus
          sx={{ gridColumn: { xs: '1', sm: '1 / span 2' } }}
          id="email"
          label={t('email')}
          type="email"
          name="email"
          fullWidth
          variant="filled"
          required
          value={email}
          onChange={onEmailChange}
          onBlur={onBlur}
          helperText={formErrors.email ? formErrors.email : ''}
          error={formErrors.email !== ''}
          disabled={isEdit}
        />
        <TextField
          sx={{ gridColumnStart: 1 }}
          name="firstName"
          label={t('first-name')}
          fullWidth
          variant="filled"
          required
          onChange={onChange}
          value={values.firstName}
          onBlur={onBlur}
          helperText={formErrors.firstName ? formErrors.firstName : ''}
          error={formErrors.firstName !== ''}
        />
        <TextField
          label={t('last-name')}
          name="lastName"
          fullWidth
          variant="filled"
          required
          onChange={onChange}
          value={values.lastName}
          onBlur={onBlur}
          helperText={formErrors.lastName ? formErrors.lastName : ''}
          error={formErrors.lastName !== ''}
        />
        <TextField
          sx={{ gridColumnStart: 1 }}
          name="phone"
          label={t('phone')}
          variant="filled"
          type="tel"
          onChange={onChange}
          value={values.phone}
        />

        <TextField
          sx={{ gridColumn: { xs: '1', sm: '1 / span 3' } }}
          label={t('responsibilities')}
          name="responsibilityDescription"
          variant="filled"
          onChange={onChange}
          value={values.responsibilityDescription}
        />
      </Box>
      <FormControlLabel
        sx={{ mt: 1 }}
        control={<Checkbox onChange={onReceiveRequestForProposalsChange} checked={values.receiveRequestForProposals} />}
        label={t('person-will-receive-request-for-proposals')}
      />
    </>
  )
}

export default UserContactForm
